import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { FormManagerPageReducerHelper } from '../form-manager-page.reducer-helper';

export const formUpdateReducer = (
    state = initialState,
    action: actions.FormUpdate
): State => {
    if (!state.form.ids.find(id => id === action.payload.form.id)) {
        return state;
    }

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            forms: arrayPushUnique(state.dirtyIds.forms, action.payload.form.id)
        },
        form: {
            ...state.form,
            entities: {
                ...state.form.entities,
                [action.payload.form.id]: action.payload.form
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/form-update.reducer.ts